/**
 * Filters names, not translated
 * Used for analytics
 */
export enum FilterName {
    Instruments = 'Instruments',
    Genres = 'Genres',
    Sfxs = 'Sfxs',
    Type = 'Type',
    TempoFilter = 'BPM',
    KeyFilter = 'Key',
    More = 'More',
    Tags = 'Tags',
}
